import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  timezone: string | null;
  socketConnected: boolean;
  socketInitialized: boolean;
  reconnectionCountdown: number;
}

const initialState: AuthState = {
  token: localStorage.getItem('jwtToken'),
  timezone: localStorage.getItem('timezone'),
  socketConnected: false,
  socketInitialized: false,
  reconnectionCountdown: 0,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
    setTimezone: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
    setSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.socketConnected = action.payload;
    },
    setSocketInitialized: (state, action: PayloadAction<boolean>) => {
      state.socketInitialized = action.payload;
    },
    setReconnectionCountdown: (state, action: PayloadAction<number>) => {
      state.reconnectionCountdown = action.payload;
    },
  },
});

export const {
  setToken,
  clearToken,
  setTimezone,
  setSocketConnected,
  setSocketInitialized,
  setReconnectionCountdown
} = authSlice.actions;
export default authSlice.reducer;